import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQueryCustomerAttributeGroups = () => {
  const surveyGroup = useMainQueryData()

  return React.useMemo(
    () => surveyGroup?.customerAttributeGroups ?? [],
    [surveyGroup?.customerAttributeGroups],
  )
}
